import Cover from "../Cover/Cover"
import Section from "../Home/Section"
import { Button , Dropdown, Option} from "@fluentui/react-components"
import DbService from "../../firebase/DbService";
import {useEffect, useState} from "react"
const options = [
    "Machine Learning",
    "Reinforcement Leanring",
    "All"
  ];

const ContentListScreen = (props)=>{
    const [query, setQuery] = useState({
        sort: "desc",
        category: "all",
        type:"all",
    })
    // props: image, title, description, links, 
    const handleChange= (key, data)=>{
        console.log(key)
        let obj = {}
        obj[key] = data
        setQuery({
            ...query,
            ...obj
        })
    }

    const getFilter = ()=>{
        let filter = {...query}
        delete filter.sort
        Object.keys(filter).map(fil=>{
            if(filter[fil] === "all"){
                delete filter[fil]
            }
        })
        return filter
    }
    useEffect(()=>{
        setQuery({
            ...query,
            ...props.filter
        })
// load 
    },[props.filter])
    return <div>
        <Cover  {...props}/>
          {/* projects section */} 
          
          <div className="ms-Grid-row" style={{marginTop:"5%"}}><div className="ms-Grid-col ms-sm1"></div>
            <div className="ms-Grid-col ms-sm12 ms-lg3">
                <img src={process.env.PUBLIC_URL+"/wave.png"}/>    
            </div>
            {/* dropdown */}
            
            <div className="ms-Grid-col ms-sm12 ms-lg3" style={{marginLeft:"2.5%"}}>
                <label style={{fontFamily:props.font}}  >Sort: </label>
                <Dropdown 
                style={{fontFamily:props.font}}
                placeholder="sort by" 
                {...props} 
                defaultValue={"Descending"}
                onOptionSelect={(e,data)=>handleChange("sort",data.optionValue)}

>
                    
                    <Option value={"asc"}>Ascending</Option>
                    <Option value={"desc"}>Descending</Option>
          
                </Dropdown>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg3" style={{marginLeft:"2.5%"}}>
                <label style={{fontFamily:props.font}} >Category: </label>
                <Dropdown 
                placeholder="Select a Field" 
                style={{fontFamily:props.font}}
                {...props} 
                defaultValue={"All"}
                onOptionSelect={(e,data)=>handleChange("category",data.optionValue)}
                >
                    
                    <Option value="all" >All</Option>
                    <Option value="ml">Machine Learning</Option>
                    <Option value="rl">Reinforcement Learning</Option>
                    <Option value="youtube">Youtube</Option>
                    <Option value="udemy">Udemy</Option>
                    <Option value="medium">Medium</Option>
                </Dropdown>
            </div>
        </div>

        

        <Section font={props.font} type={props.type} filter={getFilter()} sort={query.sort} title="Prominent Projects" noHeading={true}/>
        
        {/* CONTENT SECTION */}
        <div className="ms-Grid-row" style={{marginTop:"2.5%"}}>
        <div className="ms-Grid-col ms-sm1 ms-lg1"></div>
            <div className="ms-Grid-col ms-sm1 ms-lg4">
                <img src={process.env.PUBLIC_URL+"/wave.png"}/>    
            </div>
        </div>
    </div>
}

export default ContentListScreen